


























import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { Question } from "../../../types/DataSource";

@Component
export default class DropdownQuestionSelect extends Vue {
  @Prop({ required: true }) private question!: Question;
  @Prop({ default: "chevron-down" }) private icon!: string;
  @Model("change", { type: String }) selectedId!: string;

  private onChange(event: any) {
    this.$emit("change", event.target.value);
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--dropdown-question-icon-color": this.$store.state.globalCss.colors
        .dropdownQuestion.color
    };
  }
}
